import { render, staticRenderFns } from "./AudienceGenericModal.vue?vue&type=template&id=4851b2da&"
import script from "./AudienceGenericModal.vue?vue&type=script&lang=ts&"
export * from "./AudienceGenericModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports